module.exports = __webpack_public_path__ + "img/img1.d91b7460.png";